var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"chart-container"},[_c('div',{staticClass:"chart"},[_c('svg',{ref:"svg"})]),_c('button',{on:{"click":_vm.addRandomValue}},[_vm._v("添加随机数值")])])
}
var staticRenderFns = []

export { render, staticRenderFns }